export default __webpack_public_path__ + "fonts/fontello.844a79d072812a3b19e263c7110541a2.eot";